import React, { useState } from "react";
import { SketchPicker } from "react-color";
import { useEditCtaContext } from "../../../../../../context/EditCtaContext";

const TitleGroup = () => {
  const { formData, setFormData } = useEditCtaContext();

  const [showColorPicker, setShowColorPicker] = useState(false);

  const fonts = [
    "Roboto",
    "Montserrat",
    "Arial",
    "Helvetica",
    "Times New Roman",
    "Courier New",
    "Verdana",
    "Georgia",
  ];

  const fontSizes = Array.from({ length: 90 }, (_, i) => i + 8);

  const handleChange = (field, value) => {
    // onDataChange({ ...formData, [field]: value });
    setFormData({ ...formData, [field]: value });
  };

  const toggleStyle = (style) => {
    // onDataChange({ ...formData, [style]: !formData[style] });
    setFormData({ ...formData, [style]: !formData[style] });
  };

  const handleColorChange = (color) => {
    // onDataChange({ ...formData, titleColor: color.hex });
    setFormData({ ...formData, titleColor: color.hex });
  };

  return (
    <div className="flex flex-col px-6 pb-6">
      {/* Step Header */}
      <div className="flex flex-col pt-4 mb-12">
        <h2 className="text-white text-2xl font-semibold leading-[30px] tracking-[-0.15px] mb-0">
          Step 1
        </h2>
        <p className="text-white text-xl font-medium leading-6">
          Write your title
        </p>
      </div>

      {/* Form Fields */}
      <div className="flex flex-col gap-3">
        {/* Text Input */}
        <div className="flex flex-col gap-1">
          <label className="text-white text-base font-bold leading-[22px] tracking-[-0.18px]">
            Text
          </label>
          <input
            type="text"
            placeholder="Add a clear headline"
            value={formData.titleText}
            onChange={(e) => handleChange("titleText", e.target.value)}
            className="h-9 px-3 py-2 rounded border border-[#DCDFE3] bg-white text-base text-gray-700 placeholder:text-[#758195] focus:outline-none focus:ring-1 focus:ring-purple-500"
          />
        </div>

        {/* Font Selector */}
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-1">
            <label className="text-white text-base font-bold leading-[22px] tracking-[-0.18px]">
              Font
            </label>
            <div className="relative">
              <select
                value={formData.titleFont}
                onChange={(e) => handleChange("titleFont", e.target.value)}
                className="h-9 w-full px-3 py-2 rounded border border-[#DCDFE3] bg-white text-base text-[#758195] appearance-none focus:outline-none focus:ring-1 focus:ring-purple-500"
              >
                {fonts.map((font) => (
                  <option key={font} value={font}>
                    {font}
                  </option>
                ))}
              </select>
              <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                <svg width="8" height="22" viewBox="0 0 8 22" fill="none">
                  <path
                    d="M0 7.02468L3.84664 0.200195L8 7.00454L0 7.02468Z"
                    fill="#231F20"
                  />
                  <path
                    d="M8 14.376L4.15336 21.2005L0 14.3962L8 14.376Z"
                    fill="#231F20"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* Text Alignment Buttons */}
          <div className="flex items-center gap-1.5">
            <button
              onClick={() => handleChange("titleTextAlign", "left")}
              className={`w-[22px] h-[22px] flex items-center justify-center rounded transition-opacity ${
                formData.titleTextAlign === "left"
                  ? "opacity-100"
                  : "opacity-60"
              }`}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M19.2799 0.700195H4.16992C2.23693 0.700195 0.669922 2.2672 0.669922 4.2002V19.3102C0.669922 21.2432 2.23693 22.8102 4.16992 22.8102H19.2799C21.2129 22.8102 22.7799 21.2432 22.7799 19.3102V4.2002C22.7799 2.2672 21.2129 0.700195 19.2799 0.700195Z"
                  fill="#9492AD"
                  stroke="white"
                  strokeWidth="0.5"
                />
                <path
                  d="M19.1998 5.7998H4.25977V6.4198H19.1998V5.7998Z"
                  fill="white"
                />
                <path
                  d="M19.1998 9.55957H4.25977V10.1796H19.1998V9.55957Z"
                  fill="white"
                />
                <path
                  d="M19.1998 13.3301H4.25977V13.9501H19.1998V13.3301Z"
                  fill="white"
                />
                <path
                  d="M12.2998 17.0898H4.25977V17.7098H12.2998V17.0898Z"
                  fill="white"
                />
              </svg>
            </button>

            <button
              onClick={() => handleChange("titleTextAlign", "center")}
              className={`w-[22px] h-[22px] flex items-center justify-center rounded transition-opacity ${
                formData.titleTextAlign === "center"
                  ? "opacity-100"
                  : "opacity-60"
              }`}
            >
              <svg width="24" height="23" viewBox="0 0 24 23" fill="none">
                <path
                  d="M19.4987 0.589844H4.38867C2.45568 0.589844 0.888672 2.15685 0.888672 4.08984V19.1998C0.888672 21.1328 2.45568 22.6998 4.38867 22.6998H19.4987C21.4317 22.6998 22.9987 21.1328 22.9987 19.1998V4.08984C22.9987 2.15685 21.4317 0.589844 19.4987 0.589844Z"
                  fill="#9492AD"
                  stroke="white"
                  strokeWidth="0.5"
                />
                <path
                  d="M19.4185 5.68945H4.47852V6.30945H19.4185V5.68945Z"
                  fill="white"
                />
                <path
                  d="M19.4185 9.4502H4.47852V10.0702H19.4185V9.4502Z"
                  fill="white"
                />
                <path
                  d="M19.4185 13.2197H4.47852V13.8397H19.4185V13.2197Z"
                  fill="white"
                />
                <path
                  d="M15.9678 16.9795H7.92773V17.5995H15.9678V16.9795Z"
                  fill="white"
                />
              </svg>
            </button>

            <button
              onClick={() => handleChange("titleTextAlign", "right")}
              className={`w-[22px] h-[22px] flex items-center justify-center rounded transition-opacity ${
                formData.titleTextAlign === "right"
                  ? "opacity-100"
                  : "opacity-60"
              }`}
            >
              <svg width="24" height="23" viewBox="0 0 24 23" fill="none">
                <path
                  d="M19.7194 0.479492H4.60938C2.67638 0.479492 1.10938 2.0465 1.10938 3.97949V19.0895C1.10938 21.0225 2.67638 22.5895 4.60938 22.5895H19.7194C21.6524 22.5895 23.2194 21.0225 23.2194 19.0895V3.97949C23.2194 2.0465 21.6524 0.479492 19.7194 0.479492Z"
                  fill="#9492AD"
                  stroke="white"
                  strokeWidth="0.5"
                />
                <path
                  d="M19.6295 5.5791H4.68945V6.1991H19.6295V5.5791Z"
                  fill="white"
                />
                <path
                  d="M19.6295 9.33984H4.68945V9.95984H19.6295V9.33984Z"
                  fill="white"
                />
                <path
                  d="M19.6295 13.1094H4.68945V13.7294H19.6295V13.1094Z"
                  fill="white"
                />
                <path
                  d="M19.6299 16.8691H11.5898V17.4891H19.6299V16.8691Z"
                  fill="white"
                />
              </svg>
            </button>

            <button
              onClick={() => toggleStyle("titleIsBold")}
              className={`w-[22px] h-[22px] flex items-center justify-center rounded transition-opacity ${
                formData.titleIsBold ? "opacity-100" : "opacity-60"
              }`}
            >
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none">
                <path
                  d="M18.7802 0.46875H3.79016C1.87926 0.46875 0.330078 2.01781 0.330078 3.92871V18.9187C0.330078 20.8296 1.87926 22.3787 3.79016 22.3787H18.7802C20.6911 22.3787 22.2401 20.8296 22.2401 18.9187V3.92871C22.2401 2.01781 20.6911 0.46875 18.7802 0.46875Z"
                  fill="#9492AD"
                  stroke="white"
                  strokeWidth="0.5"
                />
                <text
                  x="6"
                  y="16"
                  fill="white"
                  fontSize="13"
                  fontWeight="700"
                  fontFamily="Montserrat, sans-serif"
                >
                  B
                </text>
              </svg>
            </button>

            <button
              onClick={() => toggleStyle("titleIsItalic")}
              className={`w-[22px] h-[22px] flex items-center justify-center rounded transition-opacity ${
                formData.titleIsItalic ? "opacity-100" : "opacity-60"
              }`}
            >
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none">
                <path
                  d="M18.7996 0.359375H3.80957C1.89867 0.359375 0.349609 1.90843 0.349609 3.81934V18.8093C0.349609 20.7202 1.89867 22.2693 3.80957 22.2693H18.7996C20.7105 22.2693 22.2596 20.7202 22.2596 18.8093V3.81934C22.2596 1.90843 20.7105 0.359375 18.7996 0.359375Z"
                  fill="#9492AD"
                  stroke="white"
                  strokeWidth="0.5"
                />
                <text
                  x="9"
                  y="16"
                  fill="white"
                  fontSize="13"
                  fontStyle="italic"
                  fontFamily="Montserrat, sans-serif"
                >
                  I
                </text>
              </svg>
            </button>

            <button
              onClick={() => toggleStyle("titleIsUnderline")}
              className={`w-[22px] h-[22px] flex items-center justify-center rounded transition-opacity ${
                formData.titleIsUnderline ? "opacity-100" : "opacity-60"
              }`}
            >
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none">
                <path
                  d="M18.8213 0.249023H3.83105C1.92015 0.249023 0.371094 1.79808 0.371094 3.70898V18.6992C0.371094 20.6101 1.92015 22.1592 3.83105 22.1592H18.8213C20.7322 22.1592 22.2812 20.6101 22.2812 18.6992V3.70898C22.2812 1.79808 20.7322 0.249023 18.8213 0.249023Z"
                  fill="#9492AD"
                  stroke="white"
                  strokeWidth="0.5"
                />
                <path
                  d="M16.6211 8.54991C16.6211 8.60991 16.6211 8.74968 16.6211 8.80968C16.6011 8.94968 16.5114 9.15989 16.4414 9.27989L13.4717 12.1695L10.6816 9.35997L13.7217 6.3795C14.3117 6.0295 15.0014 6.46954 15.4414 6.91954C15.7514 7.23954 16.5909 8.11991 16.6309 8.54991H16.6211Z"
                  fill="white"
                />
                <path
                  d="M6.65234 15.04V14.9102L6.72266 14.8003L7.91211 13.6299L9.20215 14.9302C9.08215 15.0702 8.94219 15.2803 8.74219 15.2803C8.16219 15.2403 7.51238 15.3403 6.94238 15.2803C6.78238 15.2603 6.71234 15.1903 6.65234 15.0503V15.04Z"
                  fill="white"
                />
                <path
                  d="M10.4512 10.5801L12.291 12.4302C11.741 12.9302 10.9008 13.6599 10.5908 13.8799C10.5508 13.8799 10.4916 13.8704 10.4316 13.8604C10.3216 13.8404 10.1912 13.8203 10.0312 13.8203H10.001C9.96098 13.8203 9.91109 13.8203 9.87109 13.8203L9.01074 12.96C9.01074 12.85 9.01074 12.7499 9.01074 12.6299C9.01074 12.5599 8.99145 12.4899 8.98145 12.4199C9.19145 12.0699 9.91094 11.2001 10.4609 10.5801M10.4316 9.62012C10.1816 9.88012 8.28078 11.9904 8.30078 12.3604C8.30078 12.4704 8.35133 12.5802 8.36133 12.6802C8.37133 12.8402 8.36102 13.0102 8.29102 13.1602L9.66113 14.54C9.78113 14.52 9.89074 14.4702 10.0107 14.4702H10.0312C10.2313 14.4702 10.4013 14.54 10.6113 14.54C10.6613 14.54 10.7215 14.5403 10.7715 14.5303C11.0115 14.4903 13.0514 12.63 13.2314 12.46L10.4209 9.62988L10.4316 9.62012Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Font Size Selector */}
        <div className="flex flex-col gap-1 w-20">
          <label className="text-white text-base font-bold leading-[22px] tracking-[-0.18px]">
            Font Size
          </label>
          <div className="relative">
            <select
              value={formData.titleFontSize}
              onChange={(e) => handleChange("titleFontSize", e.target.value)}
              className="h-9 w-full px-3 py-2 rounded border border-[#DCDFE3] bg-white text-base text-[#758195] appearance-none focus:outline-none focus:ring-1 focus:ring-purple-500"
            >
              {fontSizes.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
            <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
              <svg width="8" height="22" viewBox="0 0 8 22" fill="none">
                <path
                  d="M0 7.13503L3.84664 0.310547L8 7.11489L0 7.13503Z"
                  fill="#231F20"
                />
                <path
                  d="M8 14.4863L4.15336 21.3108L0 14.5066L8 14.4863Z"
                  fill="#231F20"
                />
              </svg>
            </div>
          </div>
        </div>

        {/* Title Color Picker */}
        <div className="flex flex-col gap-1">
          <label className="text-white text-base font-bold leading-[22px] tracking-[-0.18px]">
            Title Color
          </label>
          <div className="relative">
            <div
              onClick={() => setShowColorPicker(!showColorPicker)}
              className="w-11 h-11 rounded border border-white cursor-pointer"
              style={{ backgroundColor: formData.titleColor }}
            />
            {showColorPicker && (
              <div className="absolute z-10 -mt-96">
                <div
                  className="fixed inset-0"
                  onClick={() => setShowColorPicker(false)}
                />
                <SketchPicker
                  color={formData.titleColor}
                  onChange={handleColorChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TitleGroup;
